'use strict';

var BaseModal = require('./Modal/BaseModal');
var ModalManager = require('./ModalManager');

var WidgetUtils = require('./WidgetUtils');
WidgetUtils.requireStylesheet('MITS.Widgets.MessageModal');

var MessageModal = function(text, spanClassName, className) {
    this.initialize(text, spanClassName, className);
};

jQuery.extend(jQuery.extend(MessageModal.prototype, BaseModal.prototype), {
    modalText: null,
    modalId: 'messageModal',
    spanClassName: null,

    MODAL_CONTENT_CLASS: 'modalMessageContent',
    MODAL_CLASS: 'modalMessage',

    /*
        Public Methods
    */
    initialize: function(text, spanClassName, className) {
        ModalManager._currentMessageModal = this;
        this.modalText = text;
        this.className = className || 'genericMessageModal';
        this.spanClassName = spanClassName || 'genericMessage';
        this._loadMarkupOnLoad();
    },

    toString: function(){
        return '[MessageModal]';
    },

    /*
        Private Methods
    */
    _createAdditionalContent: function($modalBody) {
        $modalBody.append('<div><span class="' + this.spanClassName + '">' + this.modalText + '</span></div>');
    }
});

module.exports = MessageModal;


//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/MessageModal.js
// module id = 34
// module chunks = 0